/**
 * Sets an HTTP header with client attributes information.
 * @module lib/services/request/x-client-attributes/middleware.js
 */
const HEADER_NAME = 'x-client-attributes'
const HEADER_VALUE_SAME_ORIGIN = 'app-provider/gaia,app/admin'

/**
 * Returns a modified request object with the x-client-attributes header set to specify the same-origin client.
 *
 * @param {Object} req - The HTTP request object.
 * @returns {Object} The modified request object.
 */
export const xClientAttributesMiddleware = (req) => {
  req.set(HEADER_NAME, HEADER_VALUE_SAME_ORIGIN)
  return req
}
